import { useEffect, useRef, useState } from "react";
import { Box, Center, Heading, SimpleGrid, VStack, useToast } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { DataDump } from "../components/DeviceComponents/DataDump";
import DevicePlot from "../components/DeviceComponents/DevicePlot";
import TrackerMap from "../components/DeviceComponents/TrackerMap";
import { IDevice } from "../types/deviceInterface";
import useAxios from "../utils/useAxios";

const TrackerViewer = () => {
  const api = useAxios();
  const toast = useToast();
  const { id } = useParams<{ id: string }>();
  const apiRef = useRef(api);
  const toastRef = useRef(toast);
  const [device, setDevice] = useState<IDevice | undefined>();

  apiRef.current = api;
  toastRef.current = toast;

  useEffect(() => {
    const fetchDevice = async () => {
      try {
        const response = await apiRef.current.get(`frontend/devices/current-data/${id}/`);
        setDevice(response.data);
      } catch {
        toastRef.current({
          title: "Unable to load tracker data",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    };

    fetchDevice();
  }, [id]);

  if (!id) return null;

  return (
    <Navbar>
      <VStack mt={2} align="stretch" spacing={4}>
        <Box padding="5" m={1}>
          <Heading as="h2" size="lg" mb={4}>
            {device?.device_name || `Tracker #${id}`}
          </Heading>
          <SimpleGrid minChildWidth={{ base: "100%", xl: "360px" }} spacing={4}>
            <Box>
              <Heading size="sm" mb={2}>
                Current Data
              </Heading>
              <DataDump device={device} />
            </Box>
            <TrackerMap deviceId={id} />
          </SimpleGrid>
        </Box>
        <Center>
          <Box padding="5" m={1} width="100%" maxWidth="1300">
            <DevicePlot hideSoilMetrics />
          </Box>
        </Center>
      </VStack>
    </Navbar>
  );
};

export default TrackerViewer;
